import React, { useState } from 'react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: "Riceverai tutto via email immediatamente dopo l'acquisto."
}, {
  q: 'Posso stampare tutto?',
  a: 'Sì, tutti i file sono in formato A4 stampabile.'
}, {
  q: 'È adatto anche per BES e DSA?',
  a: 'Assolutamente sì. Include attività facilitate e strumenti inclusivi.'
}, {
  q: 'Funziona sulla LIM?',
  a: 'Sì, è compatibile con LIM, tablet e PC.'
}, {
  q: 'È un pagamento unico?',
  a: 'Sì, nessun abbonamento mensile.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-221">
          Domande Frequenti
        </h2>

        <div className="space-y-4 mb-16" data-id="element-222">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-223">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-224">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-225">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-226">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-227">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-228">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-229">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)'
        }} data-id="element-230"></div>
          <a href="#pricing" style={{
          backgroundColor: '#39FF14',
          color: '#0a0a0a',
          boxShadow: '0 0 24px rgba(57,255,20,0.65), 0 0 60px rgba(57,255,20,0.45), 0 10px 30px rgba(57,255,20,0.35)'
        }} className="relative btn-primary-pulse font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl inline-block mb-4 w-full sm:w-auto max-w-2xl border-2 border-white/30 uppercase tracking-tight transition-transform hover:scale-[1.02] active:scale-[0.99]" data-id="element-231">
            💪 SÌ! VOGLIO RIVOLUZIONARE LE MIE LEZIONI DI ARTE
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-232">
            <span data-id="element-233">⚡ Accesso Immediato</span>
            <span data-id="element-234">•</span>
            <span data-id="element-235">🛡️ Garanzia di 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}